/* global Stripe */
import {
  CLEAR_REDIRECTION,
  CLEAR_ERROR,
  SET_ERROR_MESSAGE,
  SET_REDIRECTION,
  SET_APPLE_PAY,
  THIRD_PARTY_PROMO,
} from './constants';


export function clearRedirection() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_REDIRECTION,
    });
  };
}

export function clearErrors() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_ERROR,
    });
  };
}

export function errorRedirect(message, route) {
  return (dispatch) => {
    dispatch({
      type: SET_ERROR_MESSAGE,
      error: { message: message || 'Invalid parameters!' },
    });
    return dispatch({
      type: SET_REDIRECTION,
      payload: route,
    });
  };
}

export const setApplePay = () => dispatch =>
  Stripe.applePay.checkAvailability(available => dispatch({
    type: SET_APPLE_PAY,
    payload: !!available,
  }));

export function fetchThirdPartyPromoStatus() {
  return dispatch =>
    dispatch({
      type: THIRD_PARTY_PROMO,
      payload: {
        active: false,
        context: null,
      },
    });
}



// WEBPACK FOOTER //
// ./src/app/actions.js